export default __webpack_public_path__ + "static/media/ic_mim_40.42c8b575.svg";